<template>
    <div class="addtag" :class="{on}" @click.stop="$emit('ck')"></div>
</template>
<script>
export default {
    name: 'AddTag',
    props: ['on']
}
</script>
<style lang="less" scoped>
.addtag {
    position: absolute;
    top: 0px;
    right: 0px;
    width: 40px;
    height: 40px;
    background-image: url(../assets/img/note-default.png);
    background-repeat: no-repeat;
    background-position: top right;
    background-size: contain;
    cursor: pointer;
    &.on {
        background-image: url(../assets/img/note-add.png);
    }
}
</style>




// WEBPACK FOOTER //
// src/components/AddTag.vue